import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  GET_SEARCH_CONTEXT,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getSearchContextList = (payload) => {
  return (dispatch, getState) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/searchContext/list", {
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_SEARCH_CONTEXT, payload: data.data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};
export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};
